/*所有的页面路由配置*/
import asyncComponent from './asyncComponent.js'
////懒加载导入的文件
/*Magic Comments魔术注释法     webpackChunkName: 'index' 能够修改生成文件的name名称*/
const index = asyncComponent(() => import(/* webpackChunkName: 'index' */ '../../pages/index/index'));
//const mod = asyncComponent(() => import(/* webpackChunkName: 'mod' */ '../../pages/samePart/samePart_head'));
const news = asyncComponent(() => import(/* webpackChunkName: 'news' */ '../../pages/news/index'));
const newshow = asyncComponent(() => import(/* webpackChunkName: 'newshow' */ '../../pages/newshow/index'));

const tribune = asyncComponent(() => import(/* webpackChunkName: 'tribune' */ '../../pages/tribune/index'));//论坛
const tribune_xq = asyncComponent(() => import(/* webpackChunkName: 'tribune_xq' */ '../../pages/tribune_xq/index'));//论坛
const tribune_edit = asyncComponent(() => import(/* webpackChunkName: 'tribune_edit' */ '../../pages/tribune_edit/index'));//论坛
const usersInfo = asyncComponent(() => import(/* webpackChunkName: 'usersInfo' */ '../../pages/users_info/index'));//个人中心
const treatments = asyncComponent(() => import(/* webpackChunkName: 'treatments' */ '../../pages/treatments/index'));//治疗方案
const treatments_xq = asyncComponent(() => import(/* webpackChunkName: 'treatments_xq' */ '../../pages/treatments_xq/index'));//治疗方案
const treatments_add = asyncComponent(() => import(/* webpackChunkName: 'treatments_add' */ '../../pages/treatments_add/index'));//治疗方案
const study = asyncComponent(() => import(/* webpackChunkName: 'study' */ '../../pages/study/index'));//在线课堂
const study_xq = asyncComponent(() => import(/* webpackChunkName: 'study_xq' */ '../../pages/study_xq/index'));//在线课堂
const study_list = asyncComponent(() => import(/* webpackChunkName: 'study_list' */ '../../pages/study_list/index'));//在线课堂
const study_test = asyncComponent(() => import(/* webpackChunkName: 'study_test' */ '../../pages/study_test/index'));//在线课堂
const study_test_xq = asyncComponent(() => import(/* webpackChunkName: 'study_test' */ '../../pages/study_test_xq/index'));//在线课堂

const cases = asyncComponent(() => import(/* webpackChunkName: 'cases' */ '../../pages/cases/index'));//病例录入
const cases_addOrEdit = asyncComponent(() => import(/* webpackChunkName: 'cases_addOrEdit' */ '../../pages/cases_addOrEdit/index'));//病例录入
const cases_case = asyncComponent(() => import(/* webpackChunkName: 'cases_case' */ '../../pages/cases_case/index'));//病例录入
const data_analysis = asyncComponent(() => import(/* webpackChunkName: 'data_analysis' */ '../../pages/data_analysis/index'));//病例录入



let RouterMap= [///所有路由
    { path: "/", name: "index", component: index ,chinese:'首页',isShow:true},
    ///文章类通用路由
    {path: "/news", name: "news", component: news ,chinese:'新闻中心',isShow:true},
    {path: "/news/newshow", name: "newshow", component: newshow ,chinese:'查看详情',isShow:true},
    ///文章类通用
    //帖子路由
    {path: "/tribune", name: "tribune", component: tribune ,chinese:'帖子',isShow:true},
    {path: "/tribune/xq", name: "tribune_xq", component: tribune_xq ,chinese:'帖子详情',isShow:true},
    {path: "/tribune/edit", name: "tribune_edit", component: tribune_edit ,chinese:'编辑帖子',isShow:true},
    //病例录入
    {path: "/cases", name: "cases", component: cases ,chinese:'病例列表页',isShow:true},
    {path: "/cases/add", name: "cases_add", component: cases_addOrEdit ,chinese:'病例新增',isShow:true},
    {path: "/cases/edit", name: "cases_edit", component: cases_addOrEdit ,chinese:'病例编辑',isShow:true},
    {path: "/cases/show", name: "cases_show", component: cases_addOrEdit ,chinese:'病例查看',isShow:true},
    {path: "/cases/case", name: "cases_case", component: cases_case ,chinese:'一个病人的列表页',isShow:true},

    //用户中心路由
    {path: "/usersInfo", name: "usersInfo", component: usersInfo ,chinese:'个人中心',isShow:true},
    {path: "/usersInfo", name: "usersInfo", component: usersInfo ,chinese:'个人中心',isShow:true},
    //治疗方案
    {path: "/treatments", name: "treatments", component: treatments ,chinese:'治疗方案',isShow:true},
    {path: "/treatments/xq", name: "treatments", component: treatments_xq ,chinese:'治疗方案详情',isShow:true},
    {path: "/treatments/add", name: "treatments", component: treatments_add ,chinese:'新增治疗方案',isShow:true},
    {path: "/treatments/edit", name: "treatments", component: treatments_add ,chinese:'编辑治疗方案',isShow:true},
    //在线课堂
    {path: "/study", name: "study", component: study ,chinese:'在线课堂',isShow:true},
    {path: "/study/xq", name: "study_xq", component: study_xq ,chinese:'在线课堂详情',isShow:true},
    {path: "/study/list", name: "study_list", component: study_list ,chinese:'在线课堂列表页',isShow:true},
    {path: "/study/test", name: "study_test", component: study_test ,chinese:'在线课堂测评',isShow:true},
    {path: "/study/test/xq", name: "study_test_xq", component: study_test_xq ,chinese:'在线课堂测评详情',isShow:true},
    {path: "/study/test/show", name: "study_test_show", component: study_test_xq ,chinese:'在线课堂测评结果查询',isShow:true},

    {path: "/data_analysis", name: "data_analysis", component: data_analysis ,chinese:'数据分析',isShow:true},

];

export default  RouterMap